import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-8 md:py-12 bg-white border-y border-slate-100" data-id="element-51">
      <div className="max-w-3xl mx-auto px-4 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left" data-id="element-52">
        <div className="w-12 h-12 bg-green-50 text-green-600 rounded-full flex items-center justify-center shrink-0" data-id="element-53">
          <ShieldCheck size={24} data-id="element-54" />
        </div>
        <div data-id="element-55">
          <h3 className="text-base md:text-lg font-extrabold text-slate-900 mb-1" data-id="element-56">
            🛡️ Garantía 7 días sin riesgo
          </h3>
          <p className="text-sm text-slate-500 leading-snug" data-id="element-57">
            Estamos tan seguros de la calidad de este material que te ofrecemos
            una garantía total.{' '}
            <span className="font-semibold text-slate-700" data-id="element-58">
              Si no te convence, te devolvemos el 100% de tu dinero. Sin
              preguntas.
            </span>
          </p>
        </div>
      </div>
    </section>;
}